(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('card-variant-picker')) return;

    class FCSSCardVariantPicker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.handleClick = this.handleClick.bind(this);

      const variantScript = this.querySelector('[data-cvp-variants]');

      if (!variantScript) return;

      try {
        this.variants = JSON.parse(variantScript.textContent);
      } catch (error) {
        console.error('[Card variant picker] Invalid variant data', error);
        return;
      }

      this.colorIndex = Number(this.dataset.colorIndex);
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.sizeAction = this.dataset.sizeAction || 'select';

      this.colorButtons = Array.from(
        this.querySelectorAll('[data-cvp-color]')
      );

      this.sizeButtons = Array.from(
        this.querySelectorAll('[data-cvp-size]')
      );

      this.selectedColorElement = this.querySelector(
        '[data-selected-color]'
      );

      /*
       * IMPORTANT:
       * Do not use selected_or_first_available_variant here.
       * The customer must make the first visible selection.
       */
      this.selectedColor = null;
      this.selectedSize = null;

      this.addEventListener('click', this.handleClick);

      this.resetInitialState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    resetInitialState() {
      this.selectedColor = null;
      this.selectedSize = null;

      this.removeAttribute('data-selected-variant-id');

      this.colorButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });

      this.sizeButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });

      if (this.selectedColorElement) {
        this.selectedColorElement.textContent = '';
      }

      /*
       * On first load show every Color/Size that has at least one
       * available variant, but select nothing.
       */
      this.updateOptionAvailability();
      this.clearResolvedVariantFromCard();
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;

      const colorButton = event.target.closest('[data-cvp-color]');

      if (colorButton && this.contains(colorButton)) {
        event.preventDefault();
        event.stopPropagation();

        this.selectColor(colorButton.dataset.colorValue, true);
        return;
      }

      const sizeButton = event.target.closest('[data-cvp-size]');

      if (!sizeButton || !this.contains(sizeButton)) return;

      event.preventDefault();
      event.stopPropagation();

      const selectedVariant = this.selectSize(
        sizeButton.dataset.sizeValue,
        true
      );

      if (
        selectedVariant &&
        this.sizeAction === 'open' &&
        !window.Shopify?.designMode
      ) {
        window.location.assign(
          this.buildVariantUrl(selectedVariant.id)
        );
      }
    }

    selectColor(colorValue, updateCard) {
      if (!colorValue) return null;

      const availableColorVariants = this.variants.filter(
        (variant) =>
          variant.available &&
          variant.options?.[this.colorIndex] === colorValue
      );

      if (!availableColorVariants.length) return null;

      this.selectedColor = colorValue;

      this.colorButtons.forEach((button) => {
        const isSelected =
          button.dataset.colorValue === colorValue;

        button.classList.toggle('is-active', isSelected);
        button.setAttribute(
          'aria-pressed',
          isSelected ? 'true' : 'false'
        );
      });

      if (this.selectedColorElement) {
        this.selectedColorElement.textContent = colorValue;
      }

      /*
       * If a Size had already been selected first, keep it only when
       * that exact Color + Size combination is available.
       */
      let resolvedVariant = null;

      if (this.selectedSize) {
        resolvedVariant = availableColorVariants.find(
          (variant) =>
            variant.options?.[this.sizeIndex] === this.selectedSize
        ) || null;

        if (!resolvedVariant) {
          this.clearSizeSelection();
        }
      }

      this.updateOptionAvailability();

      if (resolvedVariant) {
        if (updateCard) {
          this.updateProductCard(resolvedVariant);
        }

        return resolvedVariant;
      }

      /*
       * Preserve the existing color-image behavior:
       * preview the first available media for this Color, but DO NOT
       * mark any Size as selected and DO NOT resolve the cart variant.
       */
      if (updateCard && availableColorVariants[0]) {
        this.previewProductCard(availableColorVariants[0]);
      }

      this.clearResolvedVariantFromCard();

      return null;
    }

    selectSize(sizeValue, updateCard) {
      if (!sizeValue) return null;

      const availableSizeVariants = this.variants.filter(
        (variant) =>
          variant.available &&
          variant.options?.[this.sizeIndex] === sizeValue
      );

      if (!availableSizeVariants.length) return null;

      this.selectedSize = sizeValue;

      this.sizeButtons.forEach((button) => {
        const isSelected =
          button.dataset.sizeValue === sizeValue &&
          !button.hidden &&
          !button.disabled;

        button.classList.toggle('is-active', isSelected);
        button.setAttribute(
          'aria-pressed',
          isSelected ? 'true' : 'false'
        );
      });

      /*
       * Size-first selection is allowed.
       * If Color is not chosen yet, keep the Size selected but wait
       * until the customer chooses Color before resolving a variant.
       */
      if (!this.selectedColor) {
        this.updateOptionAvailability();
        this.clearResolvedVariantFromCard();
        return null;
      }

      const matchingVariant = availableSizeVariants.find(
        (variant) =>
          variant.options?.[this.colorIndex] === this.selectedColor
      );

      if (!matchingVariant) {
        this.clearSizeSelection();
        this.updateOptionAvailability();
        this.clearResolvedVariantFromCard();
        return null;
      }

      this.updateOptionAvailability();

      if (updateCard) {
        this.updateProductCard(matchingVariant);
      }

      return matchingVariant;
    }

    clearSizeSelection() {
      this.selectedSize = null;

      this.sizeButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    updateOptionAvailability() {
      /*
       * Colors:
       * - before Size selection: show colors having any available variant
       * - after Size selection: show only colors available in that Size
       */
      this.colorButtons.forEach((button) => {
        const colorValue = button.dataset.colorValue;

        const isAvailable = this.variants.some(
          (variant) =>
            variant.available &&
            variant.options?.[this.colorIndex] === colorValue &&
            (
              !this.selectedSize ||
              variant.options?.[this.sizeIndex] === this.selectedSize
            )
        );

        button.hidden = !isAvailable;
        button.disabled = !isAvailable;

        if (!isAvailable) {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        }
      });

      /*
       * Sizes:
       * - before Color selection: show sizes having any available variant
       * - after Color selection: show only sizes available in that Color
       */
      this.sizeButtons.forEach((button) => {
        const sizeValue = button.dataset.sizeValue;

        const matchingVariant = this.variants.find(
          (variant) =>
            variant.available &&
            variant.options?.[this.sizeIndex] === sizeValue &&
            (
              !this.selectedColor ||
              variant.options?.[this.colorIndex] === this.selectedColor
            )
        );

        const isAvailable = Boolean(matchingVariant);

        button.hidden = !isAvailable;
        button.disabled = !isAvailable;

        if (matchingVariant) {
          button.dataset.variantId = String(matchingVariant.id);
        } else {
          delete button.dataset.variantId;
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        }
      });
    }

    getProductCard() {
      return this.closest('product-card');
    }

    getVariantIdInputs(productCard = this.getProductCard()) {
      if (!productCard) return [];

      return Array.from(
        productCard.querySelectorAll(
          'product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]'
        )
      );
    }

    getAddToCartButtons(productCard = this.getProductCard()) {
      if (!productCard) return [];

      return Array.from(
        productCard.querySelectorAll(
          'product-form-component [ref="addToCartButton"], product-form-component button[type="submit"][name="add"]'
        )
      );
    }

    clearResolvedVariantFromCard() {
      const productCard = this.getProductCard();

      this.removeAttribute('data-selected-variant-id');

      if (!productCard) return;

      /*
       * Horizon renders the first available variant in the hidden
       * product-form input on the server. Clear it while Color + Size
       * are incomplete so the default variant cannot be added by mistake.
       */
      this.getVariantIdInputs(productCard).forEach((input) => {
        input.value = '';
      });

      this.getAddToCartButtons(productCard).forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      });
    }

    syncResolvedVariantToCard(variant) {
      const productCard = this.getProductCard();
      if (!productCard || !variant) return;

      const variantId = String(variant.id);

      /*
       * This is the critical cart fix: Horizon's buy-buttons form submits
       * the hidden input[name="id"]. Updating links/images alone does not
       * change the variant that /cart/add receives.
       */
      this.getVariantIdInputs(productCard).forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });

      this.getAddToCartButtons(productCard).forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });

      /* Keep Horizon's add-to-cart animation/media in sync when possible. */
      if (variant.imageUrl) {
        productCard
          .querySelectorAll('add-to-cart-component')
          .forEach((component) => {
            component.dataset.productVariantMedia = variant.imageUrl;
          });
      }
    }

    previewProductCard(variant) {
      const productCard = this.closest('product-card');

      if (
        productCard &&
        variant.mediaId &&
        typeof productCard.previewVariant === 'function'
      ) {
        productCard.previewVariant(String(variant.mediaId));
      }

      if (productCard && variant.imageUrl) {
        productCard.setAttribute(
          'data-featured-media-url',
          variant.imageUrl
        );
      }
    }

    updateProductCard(variant) {
      const productCard = this.getProductCard();
      const variantId = String(variant.id);

      /*
       * Preserve the current Horizon integration from your existing file.
       */
      if (
        productCard &&
        typeof productCard.applyVariantToLinks === 'function'
      ) {
        productCard.applyVariantToLinks(variantId);
      } else {
        const productCardLink = productCard?.querySelector(
          '[ref="productCardLink"]'
        );

        if (productCardLink) {
          productCardLink.href =
            this.buildVariantUrl(variantId);
        }
      }

      this.previewProductCard(variant);
      this.syncResolvedVariantToCard(variant);

      this.dataset.selectedVariantId = variantId;
    }

    buildVariantUrl(variantId) {
      const productUrl = new URL(
        this.dataset.productUrl || window.location.pathname,
        window.location.origin
      );

      productUrl.searchParams.set('variant', variantId);

      return productUrl.toString();
    }
    }

    customElements.define(
      'card-variant-picker',
      FCSSCardVariantPicker
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-product-count"] && !Shopify.designMode) return;
  try {
    class CollectionProductCount extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.numberElement = this.querySelector(
        '.collection-product-count__number'
      );

      this.labelElement = this.querySelector(
        '.collection-product-count__label'
      );

      this.prefixElement = this.querySelector(
        '.collection-product-count__prefix'
      );

      this.suffixElement = this.querySelector(
        '.collection-product-count__suffix'
      );

      this.countSource = this.dataset.countSource || 'filtered';
      this.singularLabel = this.dataset.singularLabel || 'product';
      this.pluralLabel = this.dataset.pluralLabel || 'products';

      if (this.countSource !== 'filtered') return;

      this.handleMutations = this.handleMutations.bind(this);
      this.syncCount = this.syncCount.bind(this);

      this.syncCount();

      this.observer = new MutationObserver(this.handleMutations);

      this.observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-results-count']
      });

      document.addEventListener(
        'shopify:section:load',
        this.syncCount
      );
    }

    disconnectedCallback() {
      this.observer?.disconnect();

      document.removeEventListener(
        'shopify:section:load',
        this.syncCount
      );
    }

    handleMutations(mutations) {
      const shouldSync = mutations.some((mutation) => {
        if (mutation.type === 'attributes') {
          return (
            mutation.target instanceof Element &&
            mutation.target.matches(
              'facets-form-component[data-results-count]'
            )
          );
        }

        const target =
          mutation.target.nodeType === Node.TEXT_NODE
            ? mutation.target.parentElement
            : mutation.target;

        if (!(target instanceof Element)) return false;

        return Boolean(
          target.closest(
            '[data-testid="products-count"], facets-form-component'
          )
        );
      });

      if (shouldSync) {
        this.queueSync();
      }
    }

    queueSync() {
      if (this.syncQueued) return;

      this.syncQueued = true;

      requestAnimationFrame(() => {
        this.syncQueued = false;
        this.syncCount();
      });
    }

    syncCount() {
      const count = this.getFilteredCount();

      if (!Number.isFinite(count)) return;

      this.updateDisplay(count);
    }

    getFilteredCount() {
      /*
       * Horizon exposes the current result count on its facets
       * component. Prefer that numeric value when available.
       */
      const facetsComponents = Array.from(
        document.querySelectorAll(
          'facets-form-component[data-page-type="collection"][data-results-count]'
        )
      );

      for (const component of facetsComponents) {
        const rawCount = component.getAttribute('data-results-count');
        const parsedCount = Number.parseInt(rawCount, 10);

        if (Number.isFinite(parsedCount)) {
          return parsedCount;
        }
      }

      /*
       * Fallback: Horizon also updates its native products-count
       * status element after AJAX filtering. Read the first number
       * from that text if the data attribute is unavailable.
       */
      const nativeCount = document.querySelector(
        '[data-testid="products-count"] [role="status"]'
      );

      if (!nativeCount) return NaN;

      const normalizedText = nativeCount.textContent
        .replace(/,/g, '')
        .trim();

      const match = normalizedText.match(/\d+/);

      if (!match) return NaN;

      return Number.parseInt(match[0], 10);
    }

    updateDisplay(count) {
      if (this.numberElement) {
        this.numberElement.textContent = String(count);
      }

      if (this.labelElement) {
        this.labelElement.textContent =
          count === 1
            ? this.singularLabel
            : this.pluralLabel;
      }
    }
  }

  if (!customElements.get('collection-product-count')) {
    customElements.define(
      'collection-product-count',
      CollectionProductCount
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-accordion"] && !Shopify.designMode) return;
  try {
    class FAQAccordionGroup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.items = Array.from(
        this.querySelectorAll(
          ':scope > .faq-accordion__items > details.faq-accordion__item'
        )
      );

      this.duration = Number(this.dataset.animationDuration) || 320;
      this.easing =
        this.dataset.animationEasing ||
        'cubic-bezier(0.4, 0, 0.2, 1)';

      this.prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.handleThemeBlockSelect =
        this.handleThemeBlockSelect.bind(this);

      this.items.forEach((item) => {
        const summary = item.querySelector(
          ':scope > .faq-accordion__summary'
        );

        summary?.addEventListener(
          'click',
          this.onSummaryClick
        );
      });

      if (
        this.dataset.openFirst === 'true' &&
        !this.items.some((item) => item.open) &&
        this.items[0]
      ) {
        this.items[0].open = true;
      }

      document.addEventListener(
        'shopify:block:select',
        this.handleThemeBlockSelect
      );
    }

    disconnectedCallback() {
      this.items?.forEach((item) => {
        const summary = item.querySelector(
          ':scope > .faq-accordion__summary'
        );

        summary?.removeEventListener(
          'click',
          this.onSummaryClick
        );

        item._faqAnimation?.cancel?.();
        item._faqContentAnimation?.cancel?.();
      });

      document.removeEventListener(
        'shopify:block:select',
        this.handleThemeBlockSelect
      );
    }

    async onSummaryClick(event) {
      event.preventDefault();

      const summary = event.currentTarget;
      const item = summary?.closest(
        'details.faq-accordion__item'
      );

      if (!item) return;

      if (item.dataset.animating === 'true') {
        return;
      }

      if (item.open) {
        await this.closeItem(item);
        return;
      }

      const openItems = this.items.filter(
        (otherItem) => otherItem !== item && otherItem.open
      );

      await Promise.all(
        openItems.map((openItem) => this.closeItem(openItem))
      );

      await this.openItem(item);
    }

    openItem(item) {
      if (item.open) {
        return Promise.resolve();
      }

      if (this.prefersReducedMotion) {
        item.open = true;
        return Promise.resolve();
      }

      const summary = item.querySelector(
        ':scope > .faq-accordion__summary'
      );

      const content = item.querySelector(
        ':scope > .faq-accordion__content'
      );

      const answer = content?.querySelector(
        '.faq-accordion__answer'
      );

      if (!summary || !content) {
        item.open = true;
        return Promise.resolve();
      }

      item.dataset.animating = 'true';

      const startHeight = item.offsetHeight;

      item.open = true;

      const endHeight =
        summary.offsetHeight + content.scrollHeight;

      item.style.height = `${startHeight}px`;
      item.style.overflow = 'hidden';

      item._faqAnimation?.cancel?.();
      item._faqContentAnimation?.cancel?.();

      item._faqAnimation = item.animate(
        [
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ],
        {
          duration: this.duration,
          easing: this.easing
        }
      );

      if (answer) {
        item._faqContentAnimation = answer.animate(
          [
            {
              opacity: 0,
              transform: 'translateY(-8px)'
            },
            {
              opacity: 1,
              transform: 'translateY(0)'
            }
          ],
          {
            duration: Math.max(180, this.duration - 40),
            easing: this.easing,
            fill: 'both'
          }
        );
      }

      return new Promise((resolve) => {
        item._faqAnimation.onfinish = () => {
          item.style.height = '';
          item.style.overflow = '';
          item.dataset.animating = 'false';

          if (answer) {
            answer.style.opacity = '';
            answer.style.transform = '';
          }

          resolve();
        };

        item._faqAnimation.oncancel = () => {
          item.style.height = '';
          item.style.overflow = '';
          item.dataset.animating = 'false';
          resolve();
        };
      });
    }

    closeItem(item) {
      if (!item.open) {
        return Promise.resolve();
      }

      if (this.prefersReducedMotion) {
        item.open = false;
        return Promise.resolve();
      }

      const summary = item.querySelector(
        ':scope > .faq-accordion__summary'
      );

      const content = item.querySelector(
        ':scope > .faq-accordion__content'
      );

      const answer = content?.querySelector(
        '.faq-accordion__answer'
      );

      if (!summary || !content) {
        item.open = false;
        return Promise.resolve();
      }

      item.dataset.animating = 'true';

      const startHeight = item.offsetHeight;
      const endHeight = summary.offsetHeight;

      item.style.height = `${startHeight}px`;
      item.style.overflow = 'hidden';

      item._faqAnimation?.cancel?.();
      item._faqContentAnimation?.cancel?.();

      item._faqAnimation = item.animate(
        [
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ],
        {
          duration: this.duration,
          easing: this.easing
        }
      );

      if (answer) {
        item._faqContentAnimation = answer.animate(
          [
            {
              opacity: 1,
              transform: 'translateY(0)'
            },
            {
              opacity: 0,
              transform: 'translateY(-6px)'
            }
          ],
          {
            duration: Math.max(140, this.duration - 80),
            easing: this.easing,
            fill: 'both'
          }
        );
      }

      return new Promise((resolve) => {
        item._faqAnimation.onfinish = () => {
          item.open = false;
          item.style.height = '';
          item.style.overflow = '';
          item.dataset.animating = 'false';

          if (answer) {
            answer.style.opacity = '';
            answer.style.transform = '';
          }

          resolve();
        };

        item._faqAnimation.oncancel = () => {
          item.style.height = '';
          item.style.overflow = '';
          item.dataset.animating = 'false';
          resolve();
        };
      });
    }

    handleThemeBlockSelect(event) {
      if (!(event.target instanceof Element)) return;
      if (!this.contains(event.target)) return;

      const selectedItem = event.target.closest(
        'details.faq-accordion__item'
      );

      if (!selectedItem) return;

      this.items.forEach((item) => {
        item.open = item === selectedItem;
        item.style.height = '';
        item.style.overflow = '';
        item.dataset.animating = 'false';
      });
    }
  }

  if (!customElements.get('faq-accordion-group')) {
    customElements.define(
      'faq-accordion-group',
      FAQAccordionGroup
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class CustomFilterSidebar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.autoApply = this.dataset.autoApply === 'true';
      this.priceDelay = Number(this.dataset.priceDelay || 700);
      this.keepFiltersVisible = this.dataset.keepFiltersVisible !== 'false';
      this.singleSelectFitSizeColor = this.dataset.singleSelectFitSizeColor !== 'false';
      this.filterCacheKey = `fcss-filter-groups-v5-target-gender:${window.location.pathname}`;
      this.priceTimer = null;
      this.isApplying = false;

      /*
       * Clear filter HTML cached by older custom-filter versions.
       * Old cached inputs can contain obsolete filter parameter/value pairs
       * after changing Search & Discovery sources.
       */
      try {
        Object.keys(localStorage).forEach((key) => {
          if (
            key.startsWith('fcss-filter-groups-v4:') ||
            key.startsWith('fcss-filter-groups-cache-v3')
          ) {
            localStorage.removeItem(key);
          }
        });
      } catch (_) {}

      this.addEventListener('change', this.handleChange);
      this.addEventListener('click', this.handleClick);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.keepFiltersVisible) {
        this.captureBaselineFilterGroups();
        this.restoreMissingFilterGroups();
        this.syncControlsFromUrl();
        this.makeFilterOptionsUsable();
      }

      this.enforceSingleSelectGroups();
      this.moveCollectionAfterAvailability();
    }

    disconnectedCallback() {
      window.clearTimeout(this.priceTimer);
      this.removeEventListener('change', this.handleChange);
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    getFilterForms() {
      return {
        desktop: this.querySelector('.cfs__desktop-wrapper [data-cfs-form]'),
        mobile: this.querySelector('.cfs__form--mobile[data-cfs-form]'),
      };
    }

    getFilterCache() {
      try {
        return JSON.parse(localStorage.getItem(this.filterCacheKey) || '{}');
      } catch (error) {
        console.warn('[Custom filters] Unable to read saved filters.', error);
        return {};
      }
    }

    saveFilterCache(cache) {
      try {
        localStorage.setItem(this.filterCacheKey, JSON.stringify(cache));
      } catch (error) {
        console.warn('[Custom filters] Unable to save filters.', error);
      }
    }

    hasActiveFilterParams() {
      const params = new URLSearchParams(window.location.search);
      return Array.from(params.keys()).some((key) => key.startsWith('filter.'));
    }

    captureBaselineFilterGroups() {
      const cache = this.getFilterCache();
      const forms = this.getFilterForms();
      const hasActiveFilters = this.hasActiveFilterParams();
      let changed = false;

      Object.entries(forms).forEach(([viewport, form]) => {
        const groups = form?.querySelector('.cfs__groups');
        if (!groups) return;

        const count = groups.querySelectorAll(':scope > .cfs__group').length;
        if (count === 0) return;

        const cachedCount = Number(cache?.[viewport]?.count || 0);

        if (!hasActiveFilters || count > cachedCount) {
          cache[viewport] = {
            count,
            html: groups.innerHTML,
          };
          changed = true;
        }
      });

      if (changed) this.saveFilterCache(cache);
    }

    restoreMissingFilterGroups() {
      const cache = this.getFilterCache();
      const forms = this.getFilterForms();

      Object.entries(forms).forEach(([viewport, form]) => {
        const groups = form?.querySelector('.cfs__groups');
        const cached = cache?.[viewport];

        if (!groups || !cached?.html) return;

        const currentCount = groups.querySelectorAll(':scope > .cfs__group').length;
        const cachedCount = Number(cached.count || 0);

        if (cachedCount > currentCount) {
          groups.innerHTML = cached.html;
        }
      });
    }

    syncControlsFromUrl() {
      const params = new URLSearchParams(window.location.search);

      this.querySelectorAll('[data-cfs-form]').forEach((form) => {
        form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach((input) => {
          input.checked = params.getAll(input.name).includes(input.value);
        });

        form.querySelectorAll('select[name^="filter."]').forEach((select) => {
          const activeValues = params.getAll(select.name);
          select.value = activeValues[0] || '';
        });

        form.querySelectorAll('input[type="number"][name^="filter."]').forEach((input) => {
          input.value = params.get(input.name) || '';
        });

        const availabilityInputs = Array.from(
          form.querySelectorAll('[data-cfs-availability-value]')
        );

        availabilityInputs.forEach((input) => {
          input.checked = params.getAll(input.name).includes(input.value);
        });

        const availabilityAll = form.querySelector('[data-cfs-availability-all]');
        if (availabilityAll) {
          availabilityAll.checked = !availabilityInputs.some((input) => input.checked);
        }

        this.updateAllActiveCounts(form);
      });
    }

    updateAllActiveCounts(form) {
      form.querySelectorAll('[data-cfs-filter-group]').forEach((group) => {
        const legend = group.querySelector('.cfs__group-label');
        if (!legend) return;

        legend.querySelector('[data-cfs-active-count]')?.remove();

        let activeCount = group.querySelectorAll(
          'input[type="checkbox"]:checked, [data-cfs-availability-value]:checked'
        ).length;

        if (activeCount === 0) {
          const select = group.querySelector('select[name^="filter."]');
          if (select?.value) activeCount = 1;
        }

        if (activeCount === 0) {
          const numberInputs = Array.from(
            group.querySelectorAll('input[type="number"][name^="filter."]')
          );
          if (numberInputs.some((input) => input.value !== '')) activeCount = 1;
        }

        if (activeCount > 0) {
          const count = document.createElement('span');
          count.setAttribute('aria-hidden', 'true');
          count.setAttribute('data-cfs-active-count', '');
          count.textContent = `(${activeCount})`;
          legend.append(' ', count);
        }
      });
    }

    makeFilterOptionsUsable() {
      this.querySelectorAll(
        '.cfs__groups input[disabled], .cfs__groups option[disabled]'
      ).forEach((control) => {
        control.disabled = false;
        control.removeAttribute('disabled');
      });
    }

    moveCollectionAfterAvailability() {
      this.querySelectorAll('[data-cfs-form]').forEach((form) => {
        const collectionGroup = form.querySelector('[data-cfs-collection-group]');
        const availabilityGroup = form.querySelector('[data-cfs-filter-role="availability"]');

        if (!collectionGroup || !availabilityGroup) return;

        if (availabilityGroup.nextElementSibling !== collectionGroup) {
          availabilityGroup.insertAdjacentElement('afterend', collectionGroup);
        }
      });
    }

    getSingleSelectGroup(input) {
      if (!this.singleSelectFitSizeColor || !(input instanceof HTMLInputElement)) {
        return null;
      }

      const group = input.closest('[data-cfs-single-select]');
      if (!group) return null;

      const role = group.dataset.cfsFilterRole;
      if (!['fit', 'size', 'color'].includes(role)) return null;

      return group;
    }

    selectOnlyCurrentValue(input) {
      const group = this.getSingleSelectGroup(input);
      if (!group || !input.checked) return;

      group.querySelectorAll('input[type="checkbox"]').forEach((otherInput) => {
        if (otherInput !== input) {
          otherInput.checked = false;
        }
      });
    }

    enforceSingleSelectGroups() {
      if (!this.singleSelectFitSizeColor) return;

      this.querySelectorAll('[data-cfs-single-select]').forEach((group) => {
        const checkedInputs = Array.from(
          group.querySelectorAll('input[type="checkbox"]:checked')
        );

        if (checkedInputs.length <= 1) return;

        const keepInput = checkedInputs[checkedInputs.length - 1];

        checkedInputs.forEach((input) => {
          input.checked = input === keepInput;
        });
      });
    }

    buildNavigationUrl(form) {
      const action = form.getAttribute('action') || window.location.pathname;
      const url = new URL(action, window.location.origin);
      const params = new URLSearchParams();
      const formData = new FormData(form);

      for (const [key, rawValue] of formData.entries()) {
        const value = String(rawValue).trim();
        if (value === '') continue;
        params.append(key, value);
      }

      url.search = params.toString();
      return url;
    }

    applyForm(form) {
      if (!(form instanceof HTMLFormElement) || this.isApplying) return;

      this.isApplying = true;
      this.classList.add('is-applying');

      const url = this.buildNavigationUrl(form);

      window.setTimeout(() => {
        window.location.assign(url.toString());
      }, 40);
    }

    handleChange = (event) => {
      const target = event.target;

      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) {
        return;
      }

      if (target.matches('[data-cfs-collection-select]')) {
        if (!target.value || this.isApplying) return;

        this.isApplying = true;
        this.classList.add('is-applying');

        window.setTimeout(() => {
          window.location.assign(target.value);
        }, 40);

        return;
      }

      if (target.matches('[data-cfs-single-select] input[type="checkbox"]')) {
        this.selectOnlyCurrentValue(target);
      }

      if (target.matches('[data-cfs-availability-all]')) {
        const group = target.closest('[data-cfs-filter-group]');

        group?.querySelectorAll('[data-cfs-availability-value]').forEach((input) => {
          input.checked = false;
        });
      } else if (target.matches('[data-cfs-availability-value]')) {
        const group = target.closest('[data-cfs-filter-group]');
        const allInput = group?.querySelector('[data-cfs-availability-all]');

        if (allInput) allInput.checked = false;
      }

      if (target.matches('[data-cfs-sort]')) {
        this.applyForm(target.form);
        return;
      }

      if (!this.autoApply) return;

      if (target.matches('[data-cfs-price]')) {
        window.clearTimeout(this.priceTimer);

        this.priceTimer = window.setTimeout(() => {
          this.applyForm(target.form);
        }, this.priceDelay);

        return;
      }

      this.applyForm(target.form);
    };

    handleClick = (event) => {
      const openButton = event.target.closest('[data-cfs-open]');

      if (openButton) {
        this.openDrawer();
        return;
      }

      const closeButton = event.target.closest('[data-cfs-close]');

      if (closeButton) {
        this.closeDrawer();
      }
    };

    handleKeydown = (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    };

    openDrawer() {
      const drawer = this.querySelector('[data-cfs-drawer]');
      const button = this.querySelector('[data-cfs-open]');

      if (!drawer) return;

      drawer.hidden = false;
      button?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cfs-lock-scroll');
      drawer.querySelector('[data-cfs-close]')?.focus();
    }

    closeDrawer() {
      const drawer = this.querySelector('[data-cfs-drawer]');
      const button = this.querySelector('[data-cfs-open]');

      if (!drawer || drawer.hidden) return;

      drawer.hidden = true;
      button?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cfs-lock-scroll');
      button?.focus();
    }
  }

  if (!customElements.get('custom-filter-sidebar')) {
    customElements.define('custom-filter-sidebar', CustomFilterSidebar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-stock-fit"] && !Shopify.designMode) return;
  try {
    class ProductStockFit extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.stockStatus = this.querySelector('[data-stock-status]');
      this.stockText = this.querySelector('[data-stock-text]');
      this.stockIconIn = this.querySelector('[data-stock-icon-in]');
      this.stockIconOut = this.querySelector('[data-stock-icon-out]');

      this.inStockText =
        this.stockStatus?.querySelector('[data-stock-text]')?.textContent?.trim() || 'In Stock';

      const variantsScript = this.querySelector('[data-psf-variants]');

      try {
        this.variants = JSON.parse(variantsScript?.textContent || '[]');
      } catch (error) {
        this.variants = [];
      }

      this.watchVariantInput();
    }

    watchVariantInput() {
      const productRoot =
        this.closest('product-information') ||
        this.closest('[data-product-id]') ||
        document;

      this.variantInput =
        productRoot.querySelector?.('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');

      if (!this.variantInput) return;

      this.handleVariantChange = () => {
        const variantId = Number(this.variantInput.value);

        if (!variantId) return;

        const variant = this.variants.find(
          (item) => Number(item.id) === variantId
        );

        if (!variant) return;

        this.updateStock(Boolean(variant.available));
      };

      this.variantInput.addEventListener(
        'change',
        this.handleVariantChange
      );

      this.observer = new MutationObserver(
        this.handleVariantChange
      );

      this.observer.observe(this.variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    disconnectedCallback() {
      this.variantInput?.removeEventListener(
        'change',
        this.handleVariantChange
      );

      this.observer?.disconnect();
    }

    updateStock(isAvailable) {
      if (!this.stockStatus || !this.stockText) return;

      const inText =
        this.stockStatus.dataset.inStockText ||
        this.dataset.inStockText ||
        'In Stock';

      const outText =
        this.stockStatus.dataset.outStockText ||
        this.dataset.outStockText ||
        'Out of Stock';

      this.stockStatus.classList.toggle(
        'is-in-stock',
        isAvailable
      );

      this.stockStatus.classList.toggle(
        'is-out-of-stock',
        !isAvailable
      );

      this.stockText.textContent =
        isAvailable ? inText : outText;

      if (this.stockIconIn) {
        this.stockIconIn.hidden = !isAvailable;
      }

      if (this.stockIconOut) {
        this.stockIconOut.hidden = isAvailable;
      }
    }
  }

  if (!customElements.get('product-stock-fit')) {
    customElements.define(
      'product-stock-fit',
      ProductStockFit
    );
  }
  } catch(e) { console.error(e); }
})();

})();
